import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import moment from 'moment';
import { articleClicked } from '../../../utils/events/articles';
import Card from '../Card';
import SmallCard from '../SmallCard';
import Link from '../../Link';
// import styles from './styles.less';

const CardList = ({ blogs }) => (
  <div>
    <Row type="flex" gutter={20}>
      {blogs &&
        blogs.map((blog, index) => {
          const date = moment(blog.date);
          const year = date.format('YYYY');
          const month = date.format('MM');
          const day = date.format('DD');
          const child =
            index > 1 ? <SmallCard blog={blog} /> : <Card blog={blog} reference="blog" />;

          return (
            <Col xs={24} sm={12} key={blog._id}>
              {blog.shortId ? (
                <div onClick={() => articleClicked(blog)}>
                  <Link
                    route="article"
                    year={year}
                    month={month}
                    day={day}
                    url={blog.shortId}
                    title={blog.title}
                  >
                    {child}
                  </Link>
                </div>
              ) : (
                child
              )}
            </Col>
          );
        })}
    </Row>
    <Row />
  </div>
);

CardList.propTypes = {
  blogs: PropTypes.array.isRequired,
};

export default CardList;
